import { Component } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { GOOGLE_CLIENT_ID } from '../../config';

/** Hides the button if <GoogleOAuthProvider> is missing (the library throws). */
class ProviderGuard extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (this.state.failed) return null;
    return this.props.children;
  }
}

export default function GoogleAuthButton({ verb = 'Continue', onCredential, onError, disabled }) {
  if (!GOOGLE_CLIENT_ID) return null;
  return (
    <ProviderGuard>
      <div className="ax-google-official" style={{ opacity: disabled ? 0.62 : 1, pointerEvents: disabled ? 'none' : 'auto' }}>
        <GoogleLogin
          width="400"
          size="large"
          shape="rectangular"
          theme="outline"
          logo_alignment="center"
          text={/sign\s*up/i.test(verb) ? 'signup_with' : 'continue_with'}
          useOneTap={false}
          ux_mode="popup"
          click_listener={() => {
            try { sessionStorage.setItem('tg_google_busy', String(Date.now())); } catch { /* private mode */ }
          }}
          onSuccess={(res) => {
            try { sessionStorage.removeItem('tg_google_busy'); } catch { /* private mode */ }
            return onCredential?.(res?.credential);
          }}
          onError={() => {
            try { sessionStorage.removeItem('tg_google_busy'); } catch { /* private mode */ }
            onError?.('Google sign-in was cancelled or failed. Please try again.');
          }}
        />
      </div>
    </ProviderGuard>
  );
}
